import type { FormHTMLAttributes, ReactNode } from 'react'

import { cn } from '@gto/ui/cn'
import { Paper } from '@gto/ui/paper'

type SectionCardProps = {
  children: ReactNode
  className?: string
  onSubmit?: FormHTMLAttributes<HTMLFormElement>['onSubmit']
}

export const SectionCard = ({ children, className, onSubmit }: SectionCardProps) => (
  <Paper
    as={onSubmit ? 'form' : 'div'}
    elevation="2"
    className={cn(
      'flex w-full max-w-[600px] flex-col gap-5 rounded-md border border-divider p-6 transition-colors duration-150 ease-in-out hover:border-text-action-active',
      className,
    )}
    onSubmit={onSubmit}
  >
    {children}
  </Paper>
)
